module.exports = __webpack_public_path__ + "static/media/Data_insight_en_mo_3-2.5d5059f1.svg";